module.exports = __webpack_public_path__ + "static/media/cycle-arrow.9484cd82.svg";